import { render, staticRenderFns } from "./purchaserDbXq.vue?vue&type=template&id=a54ea174&scoped=true"
import script from "./purchaserDbXq.vue?vue&type=script&lang=js"
export * from "./purchaserDbXq.vue?vue&type=script&lang=js"
import style0 from "./purchaserDbXq.vue?vue&type=style&index=0&id=a54ea174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54ea174",
  null
  
)

export default component.exports